export const urls = {
  analyze: "monitorings/analyze",
  monitoring: "monitoring",
  image: "image",
  rawImage: "img=",
  farmer: "farmer",
  signin: "signin",
  me: "technical",
  positive: "monitorings/history/state=positivo",
  negative: "monitorings/history/state=negativo",
  analyzePresential: "monitorings/history/state=analise_presencial"
};
